import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ZoomButton = styled(Button)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingBottom: "12px",
  width: "48px",
  height: "48px",
  minWidth: "32px",
  fontSize: "24px",
  color: "rgba(0, 0, 0, 0.54)",
  backgroundColor: "transparent",
  boxShadow: "unset",
  border: "1px solid rgba(0, 0, 0, 0.12)",

  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
  },

  "&.leftButton": {
    borderTopRightRadius: "0px",
    borderBottomRightRadius: "0px",
  },

  "&.centerButton": {
    borderLeft: "none",
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px",
    borderTopRightRadius: "0px",
    borderBottomRightRadius: "0px",
  },

  "&.rightButton": {
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px",
    borderLeft: "none",

    "&.reset": {
      width: "auto",
      fontSize: "12px",
      paddingBottom: "6px",
    },
  },
});
